import type { ConfirmVariant } from 'components/Modal/types';

export const BOUNDARIES_FIELD_NAME = 'boundaries';

export const PRIMARY_BOUNDARY_FIELD_NAME = 'primaryBoundary';

export const REASSIGN_ASSOCIATED_ACTION = 'reassignAssociated';

export const REASSIGN_PRIMARY_ACTION = 'reassignPrimary';

export const UNASSIGN_PRIMARY_ACTION = 'unassignPrimary';

export const SUCCESS_VARIANT: ConfirmVariant = 'success';

export const FIELD_UPDATE_OPTIONS = {
    shouldDirty: true,
    shouldTouch: true,
    shouldValidate: true
};
